import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrialExipedMessageRoutingModule } from './trial-exiped-message-routing.module';
import { TrialExipedMessageComponent } from './trial-exiped-message.component';


@NgModule({
  declarations: [
    TrialExipedMessageComponent
  ],
  imports: [
    CommonModule,
    TrialExipedMessageRoutingModule
  ],
  exports:[
    TrialExipedMessageComponent
  ]
})
export class TrialExipedMessageModule { }
